"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const images_1 = require("../../services/images");
const react_datepicker_1 = __importDefault(require("react-datepicker"));
const react_1 = require("react");
const flight_1 = require("../../store/redux/flight");
const react_redux_1 = require("react-redux");
const moment_1 = __importDefault(require("moment"));
const react_i18next_1 = require("react-i18next");
const DateRangeInputWeb = ({ startDate, endDate }) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const changeField = (value, field) => {
        dispatch((0, flight_1.changeSearchDetails)({ value, field }));
    };
    const [startPickerDate, setStartPickerDate] = (0, react_1.useState)(startDate ? new Date(startDate) : null);
    const [endPickerDate, setEndPickerDate] = (0, react_1.useState)(endDate ? new Date(endDate) : null);
    const [t] = (0, react_i18next_1.useTranslation)("i18n", { keyPrefix: 'search' });
    const onChange = (dates) => {
        const [startLocalDate, endLocalDate] = dates;
        setStartPickerDate(startLocalDate);
        setEndPickerDate(endLocalDate);
        if (startLocalDate != null) {
            const startDateFormatted = (0, moment_1.default)(startLocalDate).format("YYYY-MM-DD");
            changeField(startDateFormatted, 'startDate');
            if (endLocalDate != null) {
                const endDateFormatted = (0, moment_1.default)(endLocalDate).format("YYYY-MM-DD");
                changeField(endDateFormatted, 'endDate');
            }
            else {
                changeField(null, 'endDate');
            }
        }
    };
    const CustomInput = (0, react_1.forwardRef)(({ onClick }, ref) => (!startDate ?
        (0, jsx_runtime_1.jsx)("div", { className: "react-datepicker-input-placeholder", onClick: onClick, children: t("data") }) :
        (0, jsx_runtime_1.jsxs)("div", { className: "react-datepicker-input", onClick: onClick, ref: ref, children: [startDate, endDate ? ` - ${endDate}` : "", (0, jsx_runtime_1.jsx)("img", { src: images_1.icons.CancelDisabled, onClick: () => {
                        setStartPickerDate(null);
                        setEndPickerDate(null);
                        changeField(null, 'startDate');
                        changeField(null, 'endDate');
                    }, alt: "clear" })] })));
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("img", { alt: "", src: images_1.icons.Date, className: "icon" }), (0, jsx_runtime_1.jsx)(react_datepicker_1.default, { portalId: "root-portal", selected: startPickerDate, minDate: new Date(), onChange: onChange, startDate: startPickerDate, endDate: endPickerDate, dateFormat: "dd/MM/yyyy", placeholderText: t("data"), selectsRange: true, customInput: (0, jsx_runtime_1.jsx)(CustomInput, {}) })] }));
};
exports.default = DateRangeInputWeb;
